<template>
  <el-card class="elshadow">
    <el-dialog :visible.sync="uploaderPopup" width="45%" center>
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">Upload</h3></template
      >

      <div class="p-3">
        <el-upload
          class="upload-demo"
          drag
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-success="handleUploadSuccess"
          :before-upload="beforeUpload"
          :accept="['image/jpg', 'image/jpeg', 'image/png']"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            jpg/png files with a size less than 500kb
          </div>
        </el-upload>

        <div class="grid grid-cols-3 items-center gap-4 mt-4">
          <div
            class="img_wrap"
            v-for="(item, index) in Fetchedmedias"
            :key="('item-', +index)"
            @click="primaryclick(item)"
            v-show="item.type !== 'video'"
          >
            <div>
              <div>
                <img
                  :src="url1 + '/' + item.link"
                  alt="image"
                  class="w-full object-cover rounded-4px h-72px cursor-pointer"
                />
              </div>
            </div>

            <div class="previewselect" v-if="PrimaryLogoMedia._id == item._id">
              <feather-icon
                icon="CheckIcon"
                svgClasses="w-8 h-8"
                class="text-success font-semibold"
              />
            </div>
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            layout="prev,pager,next"
            :total="100"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-drawer title="" :with-header="false" :visible.sync="isShowReportBug">
      <div class="bg-primary p-4 flex justify-between items-center">
        <h3 class="text-xl Add Products text-white">Report a Bug</h3>
        <feather-icon
          icon="XIcon"
          @click="isShowReportBug = false"
          class="text-white cursor-pointer"
        />
      </div>
      <div class="p-3">
        <div class="mb-2 mt-2">
          <div class="mb-2 mt-2">
            <label>Issue Name</label>
            <el-input
              placeholder="Enter..."
              v-model="issue_name"
              maxlength="50"
              class="rounded-xl mt-2"
            />
          </div>
          <div class="mb-2 mt-2">
            <label>Issue Description</label>
            <el-input
              placeholder="Enter..."
              v-model="issue_desp"
              type="textarea"
              maxlength="100"
              class="rounded-xl mt-2"
            />
          </div>
          <label>Module</label>
          <el-select
            v-model="module_name"
            placeholder="Select"
            class="w-full mt-2"
          >
            <el-option
              v-for="item in moduleOptions"
              :key="item.moduleName"
              :label="item.moduleName"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </div>

        <div class="mb-2 mt-2">
          <label>Found On</label>
          <el-select
            v-model="foundon_name"
            placeholder="Select"
            class="w-full mt-2"
            multiple
          >
            <el-option
              v-for="item in foundOnOptions"
              :key="item.foundOn"
              :label="item.foundOn"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </div>
        <!-- <div class="mb-2 mt-2">
          <label>Issue type</label>
          <el-select
            v-model="issuetype_name"
            placeholder="Select"
            class="w-full mt-2"
          >
            <el-option
              v-for="item in issueTypeOptions"
              :key="item.issueType"
              :label="item.issueType"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </div> -->
        <div class="mb-2 mt-2">
          <label>Priority</label>
          <el-select
            v-model="priority_name"
            placeholder="Select"
            class="w-full mt-2"
          >
            <el-option
              v-for="item in priorityOptions"
              :key="item.priority"
              :label="item.priority"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </div>
        <!-- <div class="mb-2 mt-2">
          <label>Severity</label>
          <el-select
            v-model="severity_name"
            placeholder="Select"
            class="w-full mt-2"
          >
            <el-option
              v-for="item in severityOptions"
              :key="item.severity"
              :label="item.severity"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </div> -->
        <!-- <div class="mb-2 mt-2">
          <label>Issue Status</label>
          <el-select
            v-model="issueStatus_name"
            placeholder="Select"
            class="w-full mt-2"
          >
            <el-option
              v-for="item in issuestatusOptions"
              :key="item.issueStatus"
              :label="item.issueStatus"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </div> -->
        <!-- <div class="mb-2 mt-2">
          <label>Issue logged by</label>
          <el-select
            v-model="issue_logged"
            placeholder="Select"
            class="w-full mt-2"
          >
            <el-option
              v-for="item in usersOptions"
              :key="item.displayName"
              :label="item.displayName"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </div> -->
        <!-- <div class="mb-2 mt-2">
          <label>Assigned To</label>
          <el-select
            v-model="assigned_to"
            placeholder="Select"
            class="w-full mt-2"
          >
            <el-option
              v-for="item in usersOptions"
              :key="item.displayName"
              :label="item.displayName"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </div> -->
        <div class="relative">
          <label>Image</label>
          <el-input
            placeholder=""
            v-model="uploadImage"
            class="w-full mt-2"
          ></el-input>
          <div class="absolute topright1810">
            <feather-icon
              icon="UploadIcon"
              svgClasses="w-4 h-4"
              class="cursor-pointer"
              @click="uploaderPopup = true"
            />
          </div>
        </div>
        <!-- <div class="mb-2 mt-2">
          <label>Due date</label>
          <el-date-picker
            v-model="selected_date"
            type="date"
            placeholder="Pick a day"
            class="block mt-2 w-full"
          />
        </div> -->

        <div class="mt-4 flex gap-4 items-center justify-center">
          <vs-button
            class="bg-builderPrimary rounded-lg text-white py-4 px-5 font-semibold border-0 mt-4 border-0"
            @click="addIssueFunc"
          >
            Submit
          </vs-button>
          <vs-button
            class="bg-builderPrimary rounded-lg text-white py-4 px-5 font-semibold border-0 mt-4 border-0"
            @click="resetFunc()"
          >
            Reset
          </vs-button>
        </div>
      </div>
    </el-drawer>
    <div class="flex items-center">
      <img
        src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/qa.png"
        alt="image"
        class="avatar-imgw"
      />
      <div class="pl-4">
        <h2 class="fsize16 text-black font-semibold mb-2">Quality Check</h2>
        <!-- <p
          class="font-semibold text-success mb-2 fsize12 flex items-center justify-between"
        >
          Pending Sign off<span class="text-grey"> 1st April,2023</span>
        </p> -->
      </div>
    </div>

    <div class="mt-8">
      <h4 class="font-semibold fsize16 text-4f4f4f mb-2">Overview</h4>
      <p class="text-8f8f8f">
        A QA Tester tests your software thoroughly to ensure it provides quality
        experience to users who will use the product.
      </p>
    </div>

    <div class="mt-8">
      <h4 class="font-semibold fsize16 text-4f4f4f mb-2">Found a Bug?</h4>
      <p class="text-8f8f8f">
        Did you perhaps discover a bug? Tell us more about it & your QA Tester
        will work with the team to resolve it
      </p>
    </div>

    <b-form-textarea
      id="textarea-small"
      placeholder="Small textarea"
      class="h-32 border-0 bg-f4f5f6"
    ></b-form-textarea>

    <div class="mt-4">
      <!-- <button
        class="bg-f4f5f6 mb-2 rounded-full text-686868 flex items-center justify-center py-4 w-full font-semibold border-0 mt-4 border-0"
      >
        <feather-icon
          icon="PaperclipIcon"
          svgClasses="w-4 h-4"
          class="mr-2 text-686868"
        />Add Attachment
      </button> -->

      <vs-button
        @click="isShowReportBug = true"
        class="bg-builderPrimary rounded-full text-white flex items-center justify-center py-4 w-full font-semibold border-0 mt-4 border-0"
      >
        Report a Bug
      </vs-button>
      <test-case :fetchData="fetchData" @func="func" />
    </div>
  </el-card>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import testCase from "../../components/Testcases.vue";
export default {
  data() {
    return {
      isShowReportBug: false,
      // image
      uploaderPopup: false,
      uploadImage: "",
      Fetchedmedias: [],
      url1: this.$imageURL,
      PrimaryLogoMedia: {},
      // other fields
      closePopup: false,
      moduleOptions: [],
      foundOnOptions: [],
      selected_date: "",
      assigned_to: "",
      usersOptions: [],
      issue_logged: "",
      issuestatusOptions: [],
      issueStatus_name: "",
      priority_name: "",
      issue_name: "",
      issue_desp: "",
      module_name: "",
      foundon_name: "",
      issuetype_name: "",
      issueTypeOptions: [],
      priorityOptions: [],
      severity_name: "",
      severityOptions: [],
      fetchData: false,
    };
  },
  components: {
    testCase,
  },
  methods: {
    async Fetchmedia() {
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      console.log(mediaData, "1111");
      this.Fetchedmedias = mediaData.data;
      console.log(this.Fetchedmedias);
    },
    async handleUploadSuccess(name) {
      // this.centerDialogVisiblealternate = false;
      // this.centerDialogVisibleprimary = false;
      // this.centerDialogVisiblefavicon = false;
      this.$swal({
        title: "Success!",
        text: `File ${name} uploaded`,
        icon: "success",
        timer: 2000,
        buttons: false,
      });
    },
    beforeUpload(file) {
      console.log(file.name);
      let formData = new FormData();
      const fileType = file.type;
      formData.append("file", file);
      if (
        fileType.startsWith("image/jpeg") ||
        fileType.startsWith("image/png") ||
        fileType.startsWith("image/gif")
      ) {
        formData.append("type", "image");
      } else if (
        fileType.startsWith("video/mp4") ||
        fileType.startsWith("video/webm") ||
        fileType.startsWith("video/ogg")
      ) {
        formData.append("type", "video");
      } else if (fileType.startsWith("image/svg+xml")) {
        formData.append("type", "svg");
      } else {
        this.isShowDetailsAddons = false;
        this.$swal({
          title: "Error",
          text: `${file.type} not allowed`,
          icon: "error",
          timer: 5000,
          buttons: false,
        });
        return;
      }
      this.uploadFile(formData, file.name);
      return false;
    },
    async uploadFile(formData, name) {
      await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Save",
        formData,
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.Fetchedmedias = mediaData.data;
      this.handleUploadSuccess(name);
    },
    primaryclick(item) {
      console.log(item, "qwerty");
      this.PrimaryLogoMedia = item;
      this.uploadImage = this.PrimaryLogoMedia.link;
      if (this.PrimaryLogoMedia != {}) {
        this.primarySrc = this.url1 + "/" + this.PrimaryLogoMedia.link;
        this.primaryLogo = this.PrimaryLogoMedia.link;
        this.uploaderPopup = false;
      }
    },
    async getModuleList() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "issueTracker/getModuleList",
        payload
      );
      console.log(data.data, "issuestatus");
      this.moduleOptions = data.data;
    },
    async getFoundOnList() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "issueTracker/getFoundOnList",
        payload
      );
      console.log(data.data, "issuestatus");
      this.foundOnOptions = data.data;
    },
    async getIssueStatusList() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "issueTracker/getIssueStatusList",
        payload
      );
      console.log(data.data, "issuestatus");
      this.issuestatusOptions = data.data;
    },
    async getIssueTypeList() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "issueTracker/getIssueTypeList",
        payload
      );
      console.log(data.data, "issuestatus");
      this.issueTypeOptions = data.data;
    },
    async getPriorityList() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "issueTracker/getPriorityList",
        payload
      );
      console.log(data.data, "issuestatus");
      this.priorityOptions = data.data;
    },
    async getSeverityList() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "issueTracker/getSeverityList",
        payload
      );
      console.log(data.data, "issuestatus");
      this.severityOptions = data.data;
    },
    async getUsersList() {
      // let payload = {
      //   communityName: "dash",
      // };
      // let data = await this.$store.dispatch(
      //   "issueTracker/getUsersList",
      //   payload
      // );
      let data = await axios.post(
        `${process.env.VUE_APP_BASE_API}/users/getUsers`,
        {},
        {
          headers: {
            "community-name": "dash",
          },
        }
      );
      console.log(data.data, "users");
      this.usersOptions = data.data.data;
    },
    resetFunc() {
      this.issue_name = "";
      this.issue_desp = "";
      this.module_name = "";
      this.foundon_name = "";
      this.issuetype_name = "";
      this.issueStatus_name = "";
      this.assigned_to = "";
      this.priority_name = "";
      this.issue_logged = "";
      this.selected_date = "";
      this.PrimaryLogoMedia = {};
      this.uploadImage = "";
      this.severity_name = "";
    },
    async addIssueFunc() {
      const payload = new FormData();
      payload.append("projectId", this.selectedProject._id);
      payload.append("projectName", this.selectedProject.projectName);
      payload.append("tasklistID", this.selectedSprint._id);
      // payload.append("taskListIdSub", this.selectedSubSprint._id);
      payload.append("issueStatus", this.issuestatusOptions[0]._id);
      payload.append("bugSource", "Admin");

      // let payload = {
      //   tasklistID: this.selectedSprint._id,
      //   taskListIdSub: this.selectedSubSprint._id,
      //   projectId: this.selectedProject._id,
      //   projectName: this.selectedProject.projectName,
      //   issueStatus: this.issuestatusOptions[0]._id,
      //   bugSource: "Admin",
      // };
      if (this.issueStatus_name) {
        // Object.assign(payload, { issueStatus: this.issueStatus_name });
        payload.append("issueStatus", this.issueStatus_name);
      }

      if (this.severity_name) {
        // Object.assign(payload, { severity: this.severity_name });
        payload.append("severity", this.severity_name);
      }
      if (this.foundon_name) {
        // Object.assign(payload, { foundOn: [...this.foundon_name] });
        payload.append("foundOn", [...this.foundon_name]);
      }
      if (this.priority_name) {
        // Object.assign(payload, { priority: this.priority_name });
        payload.append("priority", this.priority_name);
      }
      if (this.uploadImage) {
        // Object.assign(payload, { source: "Admin" });
        // Object.assign(payload, { picture: this.uploadImage });
        // Object.assign(payload, { assignedTo: this.selectedSprint.PM[0]._id });
        payload.append("source", "Admin");
        payload.append("picture", this.uploadImage);
        payload.append("assignedTo", this.selectedSprint.PM[0]._id);
        // payload.append("assignedTo", "63e38139192b362acc0634c0");
      }
      if (this.issuetype_name) {
        // Object.assign(payload, { issueType: this.issuetype_name });
        payload.append("issueType", this.issuetype_name);
      }
      if (this.issue_desp) {
        // Object.assign(payload, { description: this.issue_desp });
        payload.append("description", this.issue_desp);
      }
      if (this.issue_name) {
        // Object.assign(payload, { issueName: this.issue_name });
        payload.append("issueName", this.issue_name);
      }
      if (this.module_name) {
        // Object.assign(payload, { moduleName: this.module_name });
        payload.append("moduleName", this.module_name);
      }
      // if (this.assigned_to) {
      //   Object.assign(payload, { assignedTo: this.assigned_to });
      // }
      // if (this.issue_logged) {
      //   Object.assign(payload, { issueLoggedBy: this.issue_logged });
      // }
      let data = await this.$store.dispatch(
        "issueTracker/addIssueList",
        payload
      );
      this.fetchData = true;
      console.log(data.data, "issuestatus");
      this.closePopup = false;
      this.isShowReportBug = false;
      await this.getIssueListOnMount();
    },
    func(params) {
      if (params === false) {
        this.fetchData = false;
      }
    },
    async getIssueListOnMount() {
      let payload = {
        tasklistID: this.selectedSprint._id,
        taskListIdSub: this.selectedSubSprint._id,
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        isDeleted: false,
      };
      let data = await this.$store.dispatch(
        "issueTracker/getIssueList",
        payload
      );
      console.log(data.data, "issuelist");
    },
  },
  async mounted() {
    await this.Fetchmedia();
    await this.getModuleList();
    await this.getFoundOnList();
    await this.getIssueStatusList();
    await this.getIssueTypeList();
    await this.getSeverityList();
    await this.getPriorityList();
    await this.getUsersList();
  },
  computed: {
    ...mapState("design", [
      "selectedSprint",
      "selectedSubSprint",
      "selectedComponent",
    ]),
    ...mapState("user", ["selectedProject", "brainedUserDetails"]),
    imageURL() {
      // return "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/";
      return this.$imageURL;
    },
  },
  watch: {
    isShowReportBug(value) {
      if (value === false) {
        this.resetFunc();
      }
    },
  },
};
</script>
